// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-content {
    margin: auto !important;
    text-align: center;
}
.full-width {
    margin-left: 60px;
    width:70%;
}
.actions{
    display: flex;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/users-setup/add-update-remove-user/add-update-remove-user.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":[".center-content {\n    margin: auto !important;\n    text-align: center;\n}\n.full-width {\n    margin-left: 60px;\n    width:70%;\n}\n.actions{\n    display: flex;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
